export default {
	currentToken: state => {
      return state.token
    }
}